import Player from '@vimeo/player';
import { VideoPlayer } from './video-player.interface';

export class VimeoVideoPlayer implements VideoPlayer {
    private player: Player;

    async load(container: HTMLElement, url: string, startPosition: number): Promise<void> {
        this.player = new Player(container, { url: url as any, responsive: true });
        await this.player.ready();
        if (startPosition > 0) {
            await this.player.setCurrentTime(startPosition);
        }
    }

    async getPosition(): Promise<number> {
        return this.player ? this.player.getCurrentTime() : Promise.resolve(0);
    }

    async pause(): Promise<void> {
        await this.player?.pause();
    }

    destroy(): void {
        this.player?.destroy();
    }

    onPlay(cb: () => void): void {
        this.player?.on('play', cb);
    }

    onPause(cb: () => void): void {
        this.player?.on('pause', cb);
    }

    onEnded(cb: () => void): void {
        this.player?.on('ended', cb);
    }
}
